import user_img from "../../assets/images/IMG_20220619_230806-fotor-bg-remover-20240623125845.png";
import experience from "../../assets/images/Experience.c08a340e.svg";
import profile from "../../assets/images/default-profile.svg";
import tolga from "../../assets/images/tolgamendi.jpg";
import projects from "../../assets/images/project.1c641686.svg";
import support from "../../assets/images/Support.32cd58a0.svg";
import coding from "../../assets/images/coding.5a68c90d.svg";
import design from "../../assets/images/design.e64e6481.svg";
import services from "../../assets/images/services.01a39e4a.svg";
import idea from "../../assets/images/idea.c7149f90.svg";
import development from "../../assets/images/development.9b47b35d.svg";
import elipse1 from "../../assets/images/elips-1.c7f3c9ef.svg";
import image3 from "../../assets/images/img3.jpg";
import image20 from "../../assets/images/img20.jpg";
import elipse2 from "../../assets/images/elips-2.0ef82b98.svg";
import elipse3 from "../../assets/images/elips-3.3e0ebc30.svg";
import elipse4 from "../../assets/images/elips-4.fabeef5c.svg";
import elipse5 from "../../assets/images/elips-5.7dd30054.svg";
import elipse6 from "../../assets/images/elips-6.abd29324.svg";
import project1 from "../../assets/images/project1.png";
import project2 from "../../assets/images/project2.png";
import project3 from "../../assets/images/project3.png";
import project4 from "../../assets/images/project4.png";
import project5 from "../../assets/images/project5.png";
import project6 from "../../assets/images/project6.png";
import project7 from "../../assets/images/project7.png";
import javascript from "../../assets/images/javascript.png";
import typescript from "../../assets/images/typescript.png";
import firebase from "../../assets/images/firebase.png";
import css from "../../assets/images/css.png";
import html from "../../assets/images/html.png";
import mongodb from "../../assets/images/mongodb.png";
import nodejs from "../../assets/images/nodejs.png";
import express from "../../assets/images/express.png";
import redux from "../../assets/images/redux.png";
import reactnative from "../../assets/images/reactnative.png";
import vscode from "../../assets/images/vscode.png";
import react_icon from "../../assets/images/react-js-icon.6c20d39c.svg";
import material_icon from "../../assets/images/material-ui-icon.2018088f.svg";
import tailwind_icon from "../../assets/images/tailwind-css-icon.9c4bdccf.svg";
import doctor from "../../assets/images/doctor.jpg";
import music from "../../assets/images/music.jpg";
import dictionary from "../../assets/images/dictionary.jpg";
import chatbot from "../../assets/images/chatbot.png";
import tolgamendi from "../../assets/images/e9919a4ce25b1865170c08a779b9c1e5.jpg";

export const image = {
  user_img,
  experience,
  profile,
  tolga,
  coding,
  project1,
  project2,
  project3,
  project4,
  project5,
  project6,
  project7,
  projects,
  coding,
  css,
  html,
  javascript,
  mongodb,
  nodejs,
  react_icon,
  material_icon,
  tailwind_icon,
  vscode,
  firebase,
  reactnative,
  express,
  redux,
  typescript,
  design,
  support,
  services,
  idea,
  development,
  elipse1,
  image3,
  image20,
  elipse1,
  elipse2,
  elipse3,
  elipse4,
  elipse5,
  elipse6,
  doctor,
  music,
  dictionary,
  tolgamendi,
  chatbot,
};
